<mat-chip class="badge tw-capitalize"
  [class.badge-green]="billingUtils.isActive(subscription)"
  [class.badge-red]="billingUtils.isSuspended(subscription) || billingUtils.isCancelled(subscription)">
  {{ subscription.status === 'non_renewing' ? 'active' : subscription.status }}
</mat-chip>
